import React, { useEffect } from "react";

const Indicators = ({
  rows,
  setRows,
  initialState,
  setting,
  setSetting,
  setIsSubmit,
  isSubmit,
  loader,
}) => {
  const createInitialState = () => ({
    selectValue: "",
    inputValue: "",
    selectPosValue: "above",
  });

  useEffect(() => {
    const nonEmptyRows = rows.filter((row) => row.selectValue !== "");
    setSetting({ ...setting, indicatorParams: nonEmptyRows });
  }, []);

  const handleSubmit = () => {
    const allSelectValuesEmpty = rows.every((item) => item.selectValue === "");
    if (allSelectValuesEmpty) {
      handleClearAll();
    }
    const nonEmptyRows = rows.filter((row) => row.selectValue !== "");
    if (nonEmptyRows.length > 0) {
      setSetting({ ...setting, indicatorParams: nonEmptyRows });
      setIsSubmit(!isSubmit);
    }
  };

  const handleSelectChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectValue = value;
    switch (value) {
      case "adl":
        newRows[index].inputValue = "0";
        newRows[index].selectPosValue = "below";
        break;
      case "adx":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;
      case "cci":
        newRows[index].inputValue = "20";
        newRows[index].selectPosValue = "below";
        break;
      case "cmf":
        newRows[index].inputValue = "20";
        newRows[index].selectPosValue = "below";
        break;
      case "macd":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "macdh":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;

      case "mfi":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;
      case "obv":
        newRows[index].inputValue = "0";
        newRows[index].selectPosValue = "below";
        break;
      case "ppo":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "pvo":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "roc":
        newRows[index].inputValue = "12";
        newRows[index].selectPosValue = "below";
        break;
      case "efi":
        newRows[index].inputValue = "13";
        newRows[index].selectPosValue = "below";
        break;
      case "mh":
        newRows[index].inputValue = "12,26,9";
        newRows[index].selectPosValue = "below";
        break;
      case "price":
        newRows[index].inputValue = "$SPX";
        newRows[index].selectPosValue = "below";
        break;
      case "rsi":
        newRows[index].inputValue = "14";
        newRows[index].selectPosValue = "below";
        break;

      case "stoch":
        newRows[index].inputValue = "14,3,3";
        newRows[index].selectPosValue = "below";
        break;
      default:
        newRows[index].inputValue = "";
    }

    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }
    handleInputChange(index, newRows[index].inputValue);
    setRows(newRows);
  };

  const handleInputChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].inputValue = value ? value : "";
    if (newRows[index].selectValue === "adl") {
      setSetting({
        ...setting,
        adlValue: value,
      });
    }
    if (newRows[index].selectValue === "adx") {
      setSetting({
        ...setting,
        adxValue: value,
      });
    }
    if (newRows[index].selectValue === "cci") {
      setSetting({
        ...setting,
        cciValue: value,
      });
    }
    if (newRows[index].selectValue === "cmf") {
      setSetting({
        ...setting,
        cmfValue: value,
      });
    }
    if (newRows[index].selectValue === "macd") {
      setSetting({
        ...setting,
        macdValue: value,
      });
    }
    if (newRows[index].selectValue === "mfi") {
      setSetting({
        ...setting,
        mfiValue: value,
      });
    }
    if (newRows[index].selectValue === "obv") {
      // setSetting({
      //   ...setting, obvValue: value
      // })
    }
    if (newRows[index].selectValue === "ppo") {
      setSetting({
        ...setting,
        ppoValue: value,
      });
    }
    if (newRows[index].selectValue === "pvo") {
      setSetting({
        ...setting,
        pvoValue: value,
      });
    }
    if (newRows[index].selectValue === "roc") {
      setSetting({
        ...setting,
        rocValue: value,
      });
    }
    if (newRows[index].selectValue === "efi") {
      setSetting({
        ...setting,
        efiValue: value,
      });
    }
    if (newRows[index].selectValue === "macdh") {
      setSetting({
        ...setting,
        macdhValue: value,
      });
    }
    if (newRows[index].selectValue === "rsi") {
      setSetting({
        ...setting,
        rsiValue: value,
      });
    }
    if (newRows[index].selectValue === "stoch") {
      setSetting({
        ...setting,
        stochValue: value,
      });
    }
    setRows(newRows);
  };

  const handleClearAll = () => {
    setRows([initialState]);
    setSetting({
      ...setting,
      clearIndicator: true,
    });
  };
  const handlePositionChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectPosValue = value;
    setRows(newRows);
  };

  const isMobileView = document.body.clientWidth <= 768;
  const options = [
    { value: "", label: "----None----" },
    { value: "adl", label: "Accumulation/Distribution Line (ADL)" },
    { value: "adx", label: "ADX Line (w/+DI and -DI)" },
    { value: "cci", label: "Commodity Channel Index (CCI)" },
    { value: "cmf", label: "Chaikin Money Flow (CMF)" },
    { value: "macd", label: "MACD" },
    { value: "macdh", label: "MACD Histogram" },
    { value: "mfi", label: "Money Flow Index (MFI)" },
    { value: "obv", label: "On Balance Volume (OBV)" },
    { value: "ppo", label: "Pct Price Oscillator (PPO)" },
    { value: "pvo", label: "Pct Volume Oscillator (PVO)" },
    { value: "roc", label: "Rate of Change (ROC)" },
    { value: "efi", label: "Force Index (EFI)" },
    { value: "stoch", label: "Full Stochastics (STOCH)" },
    { value: "rsi", label: "Relative Strength Index (RSI)" },
    // { value: "fs", label: "Full Stochastics" },
  ];

  return (
    <div className="bg-custom text-gray-900 m-1 rounded overflow-hidden shadow-lg overflow-visible col-span-4">
      <div className="px-1 py-2">
        <div className="space-y-1 mt-4">
          <div className="flex flex-row">
            <table className="table-auto" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td className="font-bold">Indicators</td>
                  <td className="font-bold" style={{ width: "100px" }}>
                    Parameters
                  </td>
                  <td className="font-bold" style={{ width: "70px" }}>
                    Position
                  </td>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={`indicator-${index}`}>
                    <td>
                      <select
                        id="colorMode"
                        value={row.selectValue}
                        onChange={(e) =>
                          handleSelectChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        {options
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.inputValue}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        placeholder="Enter parameters"
                        className={
                          isMobileView
                            ? "text-[12px] shadow appearance-none border rounded w-32 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : " text-[12px] shadow appearance-none border rounded w-32  py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      />
                    </td>
                    <td>
                      <select
                        id="positionMode"
                        value={row.selectPosValue}
                        onChange={(e) =>
                          handlePositionChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        <option value="above">Above</option>
                        {/* <option value="price">Behind Price</option>
                        <option value="ind">Behind Ind</option> */}
                        <option value="below">Below</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-row px-4">
            <button
              disabled={!setting.period || !setting.symbol}
              onClick={handleSubmit}
              className="bg-primaryColor text-white rounded p-2 mt-2 mr-2 w-full"
              id={"indicatorUpdate"}
            >
              {loader ? "please wait .." : "Update"}
            </button>
            <button
              onClick={handleClearAll}
              className="bg-primaryColor text-white rounded p-2 mt-2 ml-2 w-full"
            >
              {"Clear All"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Indicators;
